import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useResponsiveStore = defineStore("responsive", () => {
  // State
  const skipMobileMaskDisclaimerState = ref<boolean>(false);

  // Getters
  const skipMobileMaskDisclaimer = computed(
    () => skipMobileMaskDisclaimerState.value,
  );

  // Actions
  const setSkipMobileMaskDisclaimer = (skip: boolean) => {
    skipMobileMaskDisclaimerState.value = skip;
  };

  return {
    skipMobileMaskDisclaimer,
    setSkipMobileMaskDisclaimer,
  };
});
